import React from 'react'
import { connect } from 'react-redux'
import Panel from 'react-bootstrap/lib/Panel'

import Loading from 'components/Loading'

import List from './list'
import { fetchLedger } from './actions'

const Ledger  = ({ __hasFetched, __items, __me }) => {
  if (!__hasFetched) {
    return <Loading />
  }

  const header = (
    <div className="row">
      <div className="col-sm-6">Subsidiary Ledger</div>
      <div className="col-sm-6 text-right">
        <strong className="text-info">{__me.get('id')} - {__me.get('full_name')}</strong>
      </div>
    </div>
  )

  return (
    <Panel header={header}>
      <List items={__items} />
    </Panel>
  )
}

Ledger.onEnter = (store) => () => store.dispatch(fetchLedger())

function mapStateToProps(state) {
  return {
    __hasFetched: state.ledger.get('hasFetched'),
    __items: state.ledger.get('items'),
    __me: state.auth.get('me'),
  }
}

export default connect(mapStateToProps)(Ledger)



// WEBPACK FOOTER //
// ./src/containers/Ledger/index.js